import React, { useState } from 'react';
import styled from 'styled-components';
import Typography from '../common/typography/Typography';

const HeaderContainer = styled.header`
  @media (min-width: 600px) {
    padding-left: 56px;
    padding-right: 56px;
  }
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: #242424;
  color: white;

  @media (max-width: 768px) {
    justify-content: space-between;
  }
`;

const Logo = styled.img`
   width: 200px;
   @media (max-width: 600px) {
    width: 150px
  }
`;

const NavMenu = styled.nav`
  display: flex;


  @media (max-width: 768px) {
    display: none;
  }
`;

const MenuItem = styled.a   `
  text-decoration: none;
  color: white;
  margin: 0px 10px;
  &:hover {
    text-decoration: underline;
  }
`;

const Button = styled.button`
  display:flex;
  align-items:center;
  max-width: 200px;
  height: 52px;
  padding: 16px 24px;

  border-radius: 8px;
  background-color: #5b63f6;
  color: white;
  border: none;
  cursor: pointer;

  &:hover {
    background-color: #777;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const HamburgerMenu = styled.div`
  display: none;
  flex-direction: column;
  cursor: pointer;


  @media (max-width: 768px) {
    display: flex;
  }
`;

const HamburgerBar = styled.div`
  width: 25px;
  height: 3px;
  background-color: white;
`;

const MobileMenu = styled.div`
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  flex-direction: column;

  background-color: #333;
  position: absolute;
  top: 60px;
  right: 20px;
  padding: 10px;
  border-radius: 5px;
`;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <HeaderContainer>
      <Logo     src="./static/logo_r.svg"
          alt="realverse_logo"/>
       


      <NavMenu>
        <MenuItem href="#">
          <Typography size="20px" weight="600">Home</Typography>
        </MenuItem>
        <MenuItem href="#">
          <Typography size="20px" weight="600">Offline activities</Typography>
        </MenuItem>
        <MenuItem href="#">
          <Typography size="20px" weight="600">Plan & pricing</Typography>
        </MenuItem>
        <MenuItem href="#">
          <Typography size="20px" weight="600">Our partners</Typography>
        </MenuItem>
      </NavMenu>

      <Button>
        <Typography size="16px" weight="600">Discover More</Typography>
      </Button>

      <HamburgerMenu onClick={toggleMenu}>
        <HamburgerBar />
        <HamburgerBar />
        <HamburgerBar />
      </HamburgerMenu>

      <MobileMenu isOpen={isMenuOpen}>
        <MenuItem href="#">
          <Typography size="20px" weight="600">Home</Typography>
        </MenuItem>
        <MenuItem href="#">
          <Typography size="20px" weight="600">About</Typography>
        </MenuItem>
        <MenuItem href="#">
          <Typography size="20px" weight="600">Services</Typography>
        </MenuItem>
        <MenuItem href="#">
          <Typography size="20px" weight="600">Contact</Typography>
        </MenuItem>
      </MobileMenu>
    </HeaderContainer>
  );
};

export default Header;
